import { Outlet } from 'react-router-dom';

function Prayogkarta() {
  return <Outlet />;
}

export default Prayogkarta;
